import {FC} from 'react';
import capitalize from 'lodash/capitalize';

import {ColorLabel} from '@shared/components';
import {Color} from '@shared/types';
import {OrderItemRole} from '../types';

import {
  COLOR__ERROR_LIGHT,
  COLOR__ERROR_SOFT_DARK,
  COLOR__PRIMARY,
  COLOR__PRIMARY_LIGHT,
  COLOR__SUCCESS,
  COLOR__SUCCESS_LIGHT,
  COLOR__WARNING,
} from '@/theme/colors';

interface RoleColors {
  bgColor: Color;
  textColor: Color;
}

// acquired/held/selling/sold are ordinary states; orphan flags a stuck slot
// (paid for, never matched) and gets the error treatment to stand out
const role2Colors: Record<OrderItemRole, RoleColors> = {
  [OrderItemRole.acquired]: {
    bgColor: COLOR__SUCCESS_LIGHT,
    textColor: COLOR__SUCCESS,
  },
  [OrderItemRole.held]: {bgColor: '#FEF3E1', textColor: COLOR__WARNING},
  [OrderItemRole.orphan]: {
    bgColor: COLOR__ERROR_LIGHT,
    textColor: COLOR__ERROR_SOFT_DARK,
  },
  [OrderItemRole.selling]: {
    bgColor: COLOR__PRIMARY_LIGHT,
    textColor: COLOR__PRIMARY,
  },
  [OrderItemRole.sold]: {bgColor: '#E1FBF9', textColor: '#1FB0AB'},
};

interface Props {
  role: OrderItemRole;
}

export const OrderItemRoleBadge: FC<Props> = ({role}) => {
  const {bgColor, textColor} = role2Colors[role];

  return (
    <ColorLabel display="inline-flex" bgcolor={bgColor} color={textColor}>
      {capitalize(role)}
    </ColorLabel>
  );
};
